import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import {
  clientLogosQuery,
  heroImagesQuery,
  industriesQuery,
  latestBlogPostsQuery,
  safePrefetch,
} from "@/lib/publicQueries";
import { HOME_DESCRIPTION, HOME_TITLE, seoHead } from "@/lib/seo";

export const Route = createFileRoute("/")({
  loader: async ({ context }) => {
    await Promise.all([
      safePrefetch(context.queryClient, clientLogosQuery()),
      safePrefetch(context.queryClient, heroImagesQuery()),
      safePrefetch(context.queryClient, industriesQuery()),
      safePrefetch(context.queryClient, latestBlogPostsQuery()),
    ]);
  },
  head: () => seoHead({ title: HOME_TITLE, description: HOME_DESCRIPTION, path: "/" }),
  component: Index,
});
